const grabScrollContainer = document.querySelector('.grab-scroll-container');
const teamCarousel = document.getElementById('team-carousel');
const teamPrev = document.getElementById('team-prev');
const teamNext = document.getElementById('team-next');

let pos = { top: 0, left: 0, x: 0, y: 0 };

const mouseDownHandler = function (e) {
	pos = {
		left: grabScrollContainer.scrollLeft,
		top: grabScrollContainer.scrollTop,
		x: e.clientX,
		y: e.clientY,
	};
	if (e.target.tagName === 'IMG') return;
	grabScrollContainer.classList.remove('cursor-grab');
	grabScrollContainer.classList.add('cursor-grabbing');
	grabScrollContainer.classList.add('user-none');
	document.addEventListener('mousemove', mouseMoveHandler);
	document.addEventListener('mouseup', mouseUpHandler);
};

const mouseMoveHandler = function (e) {
	const dx = e.clientX - pos.x;
	const dy = e.clientY - pos.y;

	grabScrollContainer.scrollTop = pos.top - dy;
	grabScrollContainer.scrollLeft = pos.left - dx;
};

const mouseUpHandler = function () {
	document.removeEventListener('mousemove', mouseMoveHandler);
	document.removeEventListener('mouseup', mouseUpHandler);

	grabScrollContainer.classList.remove('cursor-grabbing');
	grabScrollContainer.classList.remove('user-none');
	grabScrollContainer.classList.add('cursor-grab');
};

if (grabScrollContainer) {
	grabScrollContainer.addEventListener('mousedown', mouseDownHandler);
}

if (teamCarousel && teamPrev && teamNext) {
	const getCardScrollAmount = () => {
		const card = teamCarousel.querySelector('.team-card');
		if (!card) return 324;
		const gap = parseInt(window.getComputedStyle(teamCarousel).columnGap) || 24;
		return card.offsetWidth + gap;
	};

	const updateArrows = () => {
		const isAtStart = teamCarousel.scrollLeft <= 1;
		const isAtEnd =
			teamCarousel.scrollLeft + teamCarousel.clientWidth + 1 >=
			teamCarousel.scrollWidth;
		teamPrev.classList.toggle('opacity-30', isAtStart);
		teamNext.classList.toggle('opacity-30', isAtEnd);
	};

	teamPrev.addEventListener('click', () => {
		teamCarousel.scrollBy({
			left: -getCardScrollAmount(),
			behavior: 'smooth',
		});
	});

	teamNext.addEventListener('click', () => {
		teamCarousel.scrollBy({
			left: getCardScrollAmount(),
			behavior: 'smooth',
		});
	});

	teamCarousel.addEventListener('scroll', updateArrows);
	updateArrows();
}

export default grabScrollContainer;
